<template>
  <v-container v-if="!settings" fluid fill-height>
    <v-layout align-center justify-center fill-height>
      <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
  </v-container>

  <v-container v-else>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-toolbar dark>
              <v-toolbar-title>{{$t('duo-system.settings.title')}}</v-toolbar-title>
              <v-spacer />
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-list two-line>
              <div v-for="(item, index) in parameters" :key="index">
                <v-list-tile v-if="!item.hidden">
                  <v-list-tile-content>
                    <v-card flat width="100%">
                      <v-switch v-if="item.type == 'bool'" :label="$t(item.label)" v-model="item.model"></v-switch>
                      <v-text-field v-else full-width :label="$t(item.label)" v-model="item.model"></v-text-field>
                    </v-card>
                  </v-list-tile-content>
                </v-list-tile>
              </div>
            </v-list>
            <v-alert
              v-if="global_slave"
              :value="true"
              outline
              color="blue-grey"
              icon="info"
              border="left"
              colored-border
            >{{$t('alerts.global-slave')}}</v-alert>

            <transition name="fade">
              <v-alert :value="error" type="error">{{error}}</v-alert>
            </transition>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="save()">{{$t('save')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "duo-settings",
  components: {},
  mounted() {
    this.$store.dispatch("info/fetchInfo").then(() => {
      console.log("Loading info complete");
      this.$store.dispatch("duo/settings").then(() => {
        console.log("Loading settings complete");
        this.parameters.address.model = this.settings.address;
        this.parameters.extra_load.model = this.settings.extra_load || false;
        this.parameters.video_on_slave.model =
          this.settings.video_on_slave || false;
        if (this.global_slave) {
          //non necessario, ma lo forzo comunque
          this.parameters.video_on_slave.model = true;
          this.parameters.video_on_slave.hidden = true;
        }
      });
    });
  },
  computed: {
    ...mapState("duo", ["settings"]),
    ...mapState("info", ["infos"]),
    global_slave: function() {
      return this.infos && this.infos.limits && this.infos.limits.global_slave;
    }
  },
  methods: {
    save() {
      this.$store
        .dispatch("duo/saveSettings", {
          address: this.parameters.address.model,
          extra_load: this.parameters.extra_load.model,
          video_on_slave: this.parameters.video_on_slave.model
        })
        .then(() => {})
        .catch(e => {
          this.error = e.response.data.message || e;
        });
    }
  },

  data() {
    return {
      parameters: {
        address: {
          model: "...",
          label: "duo-system.settings.gateway-address"
        },
        extra_load: {
          type: "bool",
          model: false,
          label: "duo-system.settings.gateway-local-power-supply"
        },
        video_on_slave: {
          type: "bool",
          model: false,
          label:
            "duo-system.settings.video-on-even-if-slave"
        },
        el1: {
          hidden: true,
          model: "...",
          label: "duo-system.settings.echo-limiter-tail-length"
        },
        el2: {
          hidden: true,
          model: "...",
          label: "duo-system.settings.echo-limiter-noise-threshold"
        }
      },
      error: null
    };
  }
};
</script>

<style>
</style>
